import { Observable } from 'rxjs';

import { ModuleGraph } from 'module/page/graph/module-graph';

export abstract class ModuleGraphRepositoryPort {
	public abstract observeModuleGraphsByIds(
		graphsId: string[]
	): Observable<ModuleGraph[]>;

	public abstract saveModuleGraphs(moduleGraphs: ModuleGraph[]): Promise<void>;
}
